import React from 'react';
import styles from './FeaturedEvent.module.css';
import { useNavigate } from 'react-router-dom';

const FeaturedEvent = ({ event, formatDate, isHome }) => {
    const navigate = useNavigate();

    if (!event) return null;

    const handleNavigate = () => {
        navigate("/events");
    };

    const handleBookNow = () => {
        if (event.bookingUrl) {
            window.open(event.bookingUrl, "_blank");
        }
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <div className={styles.imageWrapper}>
                    <img src={event.imageUrl} alt={event.title} />
                    <span className={styles.badge}>Featured Event</span>
                </div>

                <div className={styles.content}>
                    <span className={styles.date}>
                        {formatDate(event.date, event.time)}
                    </span>

                    <h2 className={styles.title}>{event.title}</h2>

                    <p className={styles.desc}>{event.description}</p>

                    {/* Meta Section: Only shows if at least one piece of info exists */}
                    {(event.headline || event.hostedBy) && (
                        <div className={styles.meta}>
                            {/* Conditional Headliner */}
                            {event.headline && (
                                <div className={styles.metaItem}>
                                    <span>Headliner</span>
                                    <p>{event.headline}</p>
                                </div>
                            )}
                            
                            {/* Conditional Hosted By */}
                            {event.hostedBy && (
                                <div className={styles.metaItem}>
                                    <span>Hosted By</span>
                                    <p>{event.hostedBy}</p>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Tags Section */}
                    {event.tags && event.tags.length > 0 && (
                        <div className={styles.tags}>
                            {event.tags.map((tag, i) => (
                                <span key={i}>{tag}</span>
                            ))}
                        </div>
                    )}

                    <div className={styles.bottom}>
                        <div className={styles.cta}>
                            <button 
                                className={styles.primaryBtn}
                                onClick={handleBookNow}
                            >
                                Book Now
                            </button>
                            <span className={styles.price}>
                                Starting @ ₹{event.price}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {isHome && (
                <div className={styles.viewAllDiv}>
                    <button
                        className={styles.viewAll}
                        onClick={handleNavigate}
                    >
                        View All Events
                    </button>
                </div>
            )}
        </div>
    );
};

export default FeaturedEvent;